const heatMapDesktop = {
	"mon": {
		"_23": 687608,
		"_22": 927487,
		"_21": 1104430,
		"_20": 1192537,
		"_19": 1227553,
		"_18": 1279450,
		"_17": 1390527,
		"_16": 1614026,
		"_15": 1734367,
		"_14": 1771684,
		"_13": 1792171,
		"_12": 1762095,
		"_11": 1715161,
		"_10": 1578696,
		"_9": 1341977,
		"_8": 928647,
		"_7": 507838,
		"_6": 241850,
		"_5": 118859,
		"_4": 88600,
		"_3": 105669,
		"_2": 162406,
		"_1": 268478,
		"_0": 562927,
	},
	"tue": {
		"_23": 692038,
		"_22": 932165,
		"_21": 1113427,
		"_20": 1191620,
		"_19": 1224415,
		"_18": 1278660,
		"_17": 1379793,
		"_16": 1606910,
		"_15": 1732055,
		"_14": 1774403,
		"_13": 1791615,
		"_12": 1777730,
		"_11": 1736756,
		"_10": 1620367,
		"_9": 1394123,
		"_8": 992499,
		"_7": 557473,
		"_6": 273492,
		"_5": 133253,
		"_4": 95352,
		"_3": 112813,
		"_2": 166819,
		"_1": 282094,
		"_0": 597404,
	},
	"wed": {
		"_23": 684776,
		"_22": 919454,
		"_21": 1096124,
		"_20": 1167333,
		"_19": 1196778,
		"_18": 1245119,
		"_17": 1345269,
		"_16": 1557088,
		"_15": 1677087,
		"_14": 1727283,
		"_13": 1751260,
		"_12": 1736273,
		"_11": 1700593,
		"_10": 1597901,
		"_9": 1384116,
		"_8": 988269,
		"_7": 560299,
		"_6": 275836,
		"_5": 135775,
		"_4": 95681,
		"_3": 110902,
		"_2": 169648,
		"_1": 286434,
		"_0": 601968,
	},
	"thu": {
		"_23": 675243,
		"_22": 903741,
		"_21": 1073293,
		"_20": 1138287,
		"_19": 1168945,
		"_18": 1219749,
		"_17": 1317656,
		"_16": 1525319,
		"_15": 1637332,
		"_14": 1683025,
		"_13": 1707207,
		"_12": 1697891,
		"_11": 1665442,
		"_10": 1559519,
		"_9": 1356309,
		"_8": 971244,
		"_7": 553044,
		"_6": 273527,
		"_5": 134511,
		"_4": 94604,
		"_3": 109655,
		"_2": 168846,
		"_1": 285056,
		"_0": 597085,
	},
	"fri": {
		"_23": 630164,
		"_22": 807015,
		"_21": 936392,
		"_20": 997207,
		"_19": 1045285,
		"_18": 1117063,
		"_17": 1225148,
		"_16": 1410726,
		"_15": 1524586,
		"_14": 1577046,
		"_13": 1615802,
		"_12": 1608035,
		"_11": 1602581,
		"_10": 1511115,
		"_9": 1319860,
		"_8": 953341,
		"_7": 544511,
		"_6": 269317,
		"_5": 132539,
		"_4": 94553,
		"_3": 110854,
		"_2": 170572,
		"_1": 288021,
		"_0": 601778,
	},
	"sat": {
		"_23": 601527,
		"_22": 760049,
		"_21": 861986,
		"_20": 907932,
		"_19": 917555,
		"_18": 922841,
		"_17": 950160,
		"_16": 982350,
		"_15": 989199,
		"_14": 1004002,
		"_13": 1029007,
		"_12": 1053089,
		"_11": 1051524,
		"_10": 984647,
		"_9": 855292,
		"_8": 657336,
		"_7": 412156,
		"_6": 210424,
		"_5": 110515,
		"_4": 88690,
		"_3": 111431,
		"_2": 173924,
		"_1": 285659,
		"_0": 574376,
	},
	"sun": {
		"_23": 630436,
		"_22": 825108,
		"_21": 966282,
		"_20": 1019008,
		"_19": 1010650,
		"_18": 983672,
		"_17": 992479,
		"_16": 1016216,
		"_15": 1010952,
		"_14": 1011973,
		"_13": 1028681,
		"_12": 1039775,
		"_11": 1027158,
		"_10": 940402,
		"_9": 801334,
		"_8": 602586,
		"_7": 364636,
		"_6": 184151,
		"_5": 100375,
		"_4": 86395,
		"_3": 113883,
		"_2": 172960,
		"_1": 290069,
		"_0": 567907,
	},
}

const heatMapMobile = {
	"mon": {
		"_23": 2078744,
		"_22": 2785827,
		"_21": 3263853,
		"_20": 3350857,
		"_19": 3187954,
		"_18": 2984680,
		"_17": 2783019,
		"_16": 2659516,
		"_15": 2572331,
		"_14": 2533252,
		"_13": 2512171,
		"_12": 2523457,
		"_11": 2308697,
		"_10": 2150880,
		"_9": 1922352,
		"_8": 1547567,
		"_7": 1101436,
		"_6": 634512,
		"_5": 327523,
		"_4": 236430,
		"_3": 288146,
		"_2": 465650,
		"_1": 812859,
		"_0": 1457667,
	},
	"tue": {
		"_23": 2110473,
		"_22": 2831455,
		"_21": 3310456,
		"_20": 3379335,
		"_19": 3199467,
		"_18": 2993060,
		"_17": 2755242,
		"_16": 2604286,
		"_15": 2508623,
		"_14": 2472225,
		"_13": 2459002,
		"_12": 2506231,
		"_11": 2301646,
		"_10": 2177106,
		"_9": 1987562,
		"_8": 1662016,
		"_7": 1244122,
		"_6": 753047,
		"_5": 384860,
		"_4": 260620,
		"_3": 297051,
		"_2": 472756,
		"_1": 835069,
		"_0": 1523521,
	},
	"wed": {
		"_23": 2101003,
		"_22": 2820469,
		"_21": 3292729,
		"_20": 3363317,
		"_19": 3191356,
		"_18": 2996343,
		"_17": 2769532,
		"_16": 2603627,
		"_15": 2511019,
		"_14": 2474703,
		"_13": 2473022,
		"_12": 2512856,
		"_11": 2315217,
		"_10": 2193214,
		"_9": 2013634,
		"_8": 1688613,
		"_7": 1278932,
		"_6": 773065,
		"_5": 395229,
		"_4": 262197,
		"_3": 296329,
		"_2": 474173,
		"_1": 843520,
		"_0": 1541383,
	},
	"thu": {
		"_23": 2123069,
		"_22": 2832796,
		"_21": 3296148,
		"_20": 3352751,
		"_19": 3201544,
		"_18": 3007364,
		"_17": 2797944,
		"_16": 2645516,
		"_15": 2540071,
		"_14": 2504521,
		"_13": 2499770,
		"_12": 2543597,
		"_11": 2356681,
		"_10": 2235667,
		"_9": 2061541,
		"_8": 1728277,
		"_7": 1303454,
		"_6": 785276,
		"_5": 400655,
		"_4": 265586,
		"_3": 300022,
		"_2": 480344,
		"_1": 850714,
		"_0": 1547994,
	},
	"fri": {
		"_23": 2080345,
		"_22": 2651188,
		"_21": 3004522,
		"_20": 3092697,
		"_19": 3029261,
		"_18": 2921905,
		"_17": 2790065,
		"_16": 2662673,
		"_15": 2562292,
		"_14": 2517969,
		"_13": 2502293,
		"_12": 2504995,
		"_11": 2361707,
		"_10": 2255686,
		"_9": 2074623,
		"_8": 1750060,
		"_7": 1307442,
		"_6": 781295,
		"_5": 400090,
		"_4": 272333,
		"_3": 314511,
		"_2": 499631,
		"_1": 877633,
		"_0": 1578994,
	},
	"sat": {
		"_23": 1987053,
		"_22": 2469864,
		"_21": 2755526,
		"_20": 2855189,
		"_19": 2823591,
		"_18": 2779014,
		"_17": 2781381,
		"_16": 2787853,
		"_15": 2762392,
		"_14": 2731541,
		"_13": 2724724,
		"_12": 2712445,
		"_11": 2672256,
		"_10": 2543351,
		"_9": 2273554,
		"_8": 1837479,
		"_7": 1207970,
		"_6": 612158,
		"_5": 318398,
		"_4": 263177,
		"_3": 342473,
		"_2": 556373,
		"_1": 936102,
		"_0": 1588195,
	},
	"sun": {
		"_23": 1958304,
		"_22": 2565081,
		"_21": 2949596,
		"_20": 3043722,
		"_19": 2979826,
		"_18": 2893557,
		"_17": 2859164,
		"_16": 2875186,
		"_15": 2841057,
		"_14": 2797557,
		"_13": 2758414,
		"_12": 2722740,
		"_11": 2649179,
		"_10": 2462783,
		"_9": 2146163,
		"_8": 1656606,
		"_7": 1029638,
		"_6": 506477,
		"_5": 275558,
		"_4": 252624,
		"_3": 347832,
		"_2": 558347,
		"_1": 955741,
		"_0": 1571461,
	},
}

const trafficSources = {
	_Organic_Search: [41,37.1]
}

const covidEffect = {
	_Delayed_Purchase: [52],
	_Delayed_Sale: [12],
	_Speed_Purchase: [14],
	_Speed_Sale: [6],
	_Other: [16]
}

const topCountries = [
	{
		country: 'm.topcountries.usa',
		total: 51.0,
		yoy: 13,
		change: 'static'
	},
	{
		country: 'm.topcountries.uk',
		total: 6.0,
		yoy: 27,
		change: 'static'
	},
	{
		country: 'm.topcountries.india',
		total: 4.2,
		yoy: 54,
		change: 'static'
	},
	{
		country: 'm.topcountries.honhkong',
		total: 2.5,
		yoy: 32,
		change: 'static'
	},
	{
		country: 'm.topcountries.australia',
		total: 2.3,
		yoy: 33,
		change: 'static'
	},
	{
		country: 'm.topcountries.germany',
		total: 2.0,
		yoy: 38,
		change: 'static'
	},
	{
		country: 'm.topcountries.china',
		total: 1.9,
		yoy: 79,
		change: 'up',
        changeAmnt: '+2'
    },
	{
		country: 'm.topcountries.france',
		total: 1.8,
		yoy: 60,
		change: 'static'
	},
	{
		country: 'm.topcountries.mexico',
		total: 1.7,
		yoy: 29,
		change: 'down',
        changeAmnt: '-2'
	},
	{
		country: 'm.topcountries.brazil',
		total: 1.3,
		yoy: 43,
		change: 'up',
        changeAmnt: '+1'
	}
]

export default {
  heatMapMobile,
  heatMapDesktop,
	trafficSources,
	covidEffect,
	topCountries
}